import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { rankWith, scopeEndIs } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { TradingPlatform } from '@thinkalpha/ui-types/types/admin/index';
import React, { useMemo } from 'react';
import { Combobox } from 'src/components/ui';
import { useAllAccounts } from 'src/hooks/accounts/useAccounts';

interface AccountsControlComponentProps {
    data: any;
    path: string;
    description?: string;
    errors: string;
    visible: boolean;

    handleChange(path: string, value: any): void;
}

const AccountControlComponent = ({ data, path, errors, visible, handleChange }: AccountsControlComponentProps) => {
    const accounts = useAllAccounts();
    const accountItems = useMemo(() => {
        return accounts
            .filter((account) => account.tradingPlatform === TradingPlatform.Alpha)
            .map((account) => ({
                value: account.id,
                label: account.name,
                isSelected: data === account.id,
            }));
    }, [accounts, data]);

    const selectedAccountLabel = useMemo(() => accountItems.find((acc) => acc.isSelected)?.label || '', [accountItems]);

    return visible ? (
        <div>
            <Combobox
                items={accountItems}
                handleSelectItem={(item) => handleChange(path, item.value)}
                commandEmptyText="Please select an account."
                className="w-full"
            >
                {!selectedAccountLabel && <>Select an account</>}
                {selectedAccountLabel}
                <FontAwesomeIcon icon={faPlus} />
            </Combobox>
            {errors && <div className="mt-[3px] text-sm leading-[1.66] text-[#f44336]">{errors}</div>}
        </div>
    ) : null;
};

export const AccountControlTester = rankWith(
    3, //increase rank as needed
    scopeEndIs('account'),
);

export const AccountControl = withJsonFormsControlProps(AccountControlComponent);
